<!-- Delete Overlay -->
<app-confirmation-window
    #deleteConfirmationOverlay
    [mainLabel]="
        'forms.channels.custom-graph.delete-confirmation-prompt' | translate
    "
    [confirmLabel]="
        'forms.channel.custom-group.delete-confirmation-button' | translate
    "
    [cancelLabel]="
        'forms.channel.custom-group.delete-cancel-button' | translate
    "
></app-confirmation-window>

<div
    *ngIf="shareSettingsOpened && isCustomGraphType(selectedGraph)"
    class="share-settings-container"
>
    <div class="share-settings-wrapper">
        <app-page-share-settings
            [ngClass]="['share-settings', responsive.screenSize]"
            [isPublic]="selectedGraph?.publicAccess"
            [inViewPage]="true"
            [usersAccess]="usersAccess"
            (onUpdatePageAccess)="updatePageAccess($event)"
            (oncloseSettings)="changeShareSettings($event)"
            (onUpdateUsersAccess)="updateUsersAccess($event)"
            (onUpdatePageAccess)="updatePageAccess($event)"
        >
        </app-page-share-settings>
    </div>
</div>

<div class="container" *ngIf="viewInit; else loadingSpinner">
    <!-- View Selection -->
    <div
        [ngClass]="[
            'views-container',
            responsive.deviceAndOrientation,
            responsive.screenSize,
        ]"
        *ngIf="filteredGraphList"
    >
        <app-scroll-navigator
            class="scroll-navigator-container"
            [items]="filteredGraphList"
            [selectedId]="selectedGraph?.id"
            [routerPath]="['/ops', 'graphs', '']"
        />

        <a class="create-group-button" (click)="createCustomGraph()">
            <mat-icon svgIcon="blue-add" />
            <p style="text-wrap: nowrap">
                {{ "custom-graph.create.buttom" | translate }}
            </p>
        </a>
    </div>

    <div
        class="container-width graph-container"
        #mainContent
        [style]="{
            height:
                !isCustomGraphType(selectedGraph) &&
                selectedGraph?.type === EXHAUST_GRAPH
                    ? getHeight() + 'px'
                    : '100%',
        }"
    >
        <div class="exhaust-tab-container">
            <div
                class="exhaust-tab"
                *ngFor="let exhaustTab of exhaustTabArr; index as i"
                (click)="scrollToClickedSetion(exhaustTab.type, i)"
                [ngClass]="
                    exhaust
                        ? checkIfSectionInView(exhaustTab.type)
                            ? 'active'
                            : ''
                        : ''
                "
            >
                {{ "graph.exhaust".concat(".", exhaustTab.type) | translate }}
            </div>
        </div>
        <div
            class="custom-graph-details"
            *ngIf="isCustomGraphType(selectedGraph)"
        >
            <div class="lock-option">
                <mat-icon class="lock-icon" svgIcon="{{ graphAccessIcon }}">
                </mat-icon>
                <div data-cy="graphs-custom-graph-access-label">
                    {{
                        graphAccessTypeTile.concat(".", graphAccessType)
                            | translate
                    }}
                </div>
            </div>
            <div data-cy="graphs-custom-graph-title" class="graph-type-title">
                {{ "custom-graph.title" | translate }}
            </div>

            <div class="graph-title-container">
                <div
                    data-cy="graphs-custom-graph-custom-title"
                    class="graph-title"
                >
                    {{
                        isCustomGraphType(selectedGraph)
                            ? selectedGraph.displayName
                            : selectedGraph.title
                    }}
                </div>
                <div class="button-container">
                    <app-custom-page-right-buttons
                        class="custom-buttons"
                        [usersAccess]="usersAccess"
                        (onShareButtonClick)="changeShareSettings($event)"
                        (onEditButtonClick)="customGraphEdit(selectedGraph)"
                        (onDeleteButtonClick)="customDelete($event)"
                    />
                    <div class="icons-wrapper">
                        <mat-icon
                            data-cy="graphs-screenshot-icon"
                            svgIcon="screenshot"
                            [ngClass]="['header-icon', responsive.screenSize]"
                            (click)="saveScreenshot()"
                        ></mat-icon>
                    </div>
                </div>
            </div>
        </div>

        <app-exhaust-graph
            *ngIf="
                !isCustomGraphType(selectedGraph) &&
                selectedGraph?.type === EXHAUST_GRAPH
            "
            [graph]="selectedGraph[selectedGraph.type]"
            [channels]="channelObj"
            [title]="selectedGraph.title"
        ></app-exhaust-graph>
        <app-bar-graph
            *ngIf="
                !isCustomGraphType(selectedGraph) &&
                selectedGraph?.type === BAR_GRAPH
            "
            [graph]="selectedGraph[selectedGraph.type]"
            [channels]="channelObj"
            [title]="selectedGraph.title"
        ></app-bar-graph>
        <app-analog-graph
            *ngIf="
                !isCustomGraphType(selectedGraph) &&
                selectedGraph?.type === GAUGE_GRAPH
            "
            [graph]="selectedGraph[selectedGraph.type]"
            [channels]="channelObj"
        ></app-analog-graph>
        <div
            class="graph-custom-type-container"
            #customGraphContainer
            *ngIf="isCustomGraphType(selectedGraph)"
        >
            <div
                class="custom-graph-container"
                *ngFor="
                    let customGraph of selectedGraph.graphList;
                    let i = index
                "
                [style.top]="customGraph?.y + 'px'"
                [style.left]="customGraph?.x + 'px'"
                [class.gauge]="isCustomGraphTypeGauge(customGraph)"
                [class.meter]="isCustomGraphTypeMeter(customGraph)"
                [class.indicator]="isCustomGraphTypeIndicator(customGraph)"
                [class.select]="selectedNum === i"
            >
                <app-gauge-graph
                    class="custom-graph"
                    *ngIf="isCustomGraphTypeGauge(customGraph)"
                    [channel]="customGraph?.channel"
                    [divisions]="customGraph?.divisions"
                    [isCustom]="customGraph.isCustom"
                ></app-gauge-graph>
                <app-custom-bar-graph
                    class="custom-graph"
                    *ngIf="isCustomGraphTypeMeter(customGraph)"
                    [channel]="customGraph?.channel"
                    [divisions]="customGraph?.divisions"
                ></app-custom-bar-graph>
                <app-custom-indicator-graph
                    class="custom-graph"
                    *ngIf="isCustomGraphTypeIndicator(customGraph)"
                    [channel]="customGraph?.channel"
                    [divisions]="customGraph?.divisions"
                ></app-custom-indicator-graph>
            </div>
        </div>
    </div>
</div>

<ng-template #loadingSpinner>
    <div class="loading-spinner-container">
        {{ "general.notification.retreiving-data" | translate }}
        <app-loading-spinner
            style="height: 200px; width: 200px"
        ></app-loading-spinner>
    </div>
</ng-template>
